<app-navbar>
    <h2>Cariera mea - Profilul meu</h2>
</app-navbar>

<div class="main-candidate-profile-row light-grey-background ptb-60">
    <div class="container">
        <div class="row">
            <div class="col-lg-2">
                <div class="profile-photo-wrapper">
                    <img src='{{profilePicture}}' alt="profile photo" />
                </div>
            </div>
            <div class="col-lg-10">
                <div class="candidate-main-info">
                    <h3 class="custom-section-title">{{candidateData.firstName}} {{candidateData.lastName}}</h3>
                    <p>{{candidateData.currentJob}}</p>
                    <p class="address-info"><i class="fas fa-map-marker-alt"></i>{{candidateData.city}},
                        {{candidateData.userCountry}}</p>
                </div>
                <div class="candidate-edit-profile row">
                    <!-- //TODO de pus in alta parte ca arata groaznic -->
                    <a routerLink="/editeaza-profilul" class="round-button orange-background">Editeaza profilul</a>
                    <a routerLink="/aplicatiile-mele" class="round-button green-background">Aplicarile mele</a>
                    <a routerLink="/profil-candidat/{{candidateData.id}}" class="round-button yellow-background">Vezi
                        profil public</a>
                    <a (click)="generatePdf()" class="round-button blue-background">Descarca CV</a>
                </div>
                <div class="candidate-skills">
                    <div class="skills-list">
                        <div *ngFor="let skill of candidateData.ability" class="skill-item">
                            <span>{{skill.abilityName}}</span>
                        </div>
                    </div>
                </div>
                <div class="candidate-action-buttons row justify-content-between">
                    <!--                    <a class="round-button green-background">Creeaza si aplica CV</a>-->
                    <!--                    <a class="round-button yellow-background">Testeaza-ti cunostintele</a>-->
                    <!--                    <a class="round-button blue-background">E_learning</a>-->
                </div>

            </div>
            <!--            <div class="col-lg-4">-->
            <!--                <div class="row justify-content-center candidate-specs-first-row">-->

            <!--                    <div class="col-md-6">-->
            <!--                        <p class="counter-title">Salariu</p>-->
            <!--                        <p class="counter-number">59</p>-->
            <!--                    </div>-->
            <!--                    <div class="col-md-6">-->
            <!--                        <p class="counter-title">Job-uri aplicate</p>-->
            <!--                        <p class="counter-number">5</p>-->
            <!--                    </div>-->
            <!--                </div>-->

            <!--                <div class="row candidate-specs-second-row">-->
            <!--                    <div class="col-md-6">-->
            <!--                        <p class="counter-title">Nivel experienta</p>-->
            <!--                        <p class="counter-number">17</p>-->
            <!--                    </div>-->
            <!--                    <div class="col-md-6">-->
            <!--                        <p class="counter-title">Limbi straine</p>-->
            <!--                        <p class="counter-number">17</p>-->
            <!--                    </div>-->
            <!--                </div>-->

            <!--            </div>-->
        </div>
    </div>
</div>


<div class="about-candidate-section ptb-80">
    <div class="container">
        <div class="row pb-20">
            <div class="col-md-8">
                <h2 class="custom-section-title">Date personale</h2>
                <div class="row">
                    <div class="col-md-6">
                        <p><b>Adresa email: </b> {{candidateData.email}} </p>
                    </div>
                    <div class="col-md-6">
                        <p><b>Telefon: </b> {{candidateData.telephone}} </p>
                    </div>
                    <div class="col-md-6">
                        <p><b>Data nasterii: </b> {{candidateData.dateOfBirth | date:"dd-MM-yyyy"}} </p>
                    </div>
                    <div class="col-md-6">
                        <p *ngIf="candidateData.gender"><b>Sex: </b> {{candidateData.gender | enumTransform}} </p>
                    </div>
                    <div class="col-md-6">
                        <p><b>Tara domiciliu: </b> {{candidateData.userCountry}} </p>
                    </div>
                    <div class="col-md-6">
                        <p><b>Judet domiciliu: </b> {{candidateData.city}} </p>
                    </div>
                    <div class="col-md-6">
                        <p *ngIf="candidateData.civilStatus"><b>Stare civila: </b> {{candidateData.civilStatus | enumTransform}} </p>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <h2 class="custom-section-title">Social Media</h2>
                <div class="social-wrapper">
                    <a href="{{candidateData.facebookProfile}}" *ngIf="candidateData.facebookProfile" target="_blank"><i
                            class="icofont-facebook"></i>Facebook</a>
                    <a href="{{candidateData.linkedinProfile}}" *ngIf="candidateData.linkedinProfile" target="_blank"><i
                            class="icofont-linkedin"></i>LinkedIn</a>
                    <a href="{{candidateData.youtubeProfile}}" *ngIf="candidateData.youtubeProfile" target="_blank"><i
                            class="icofont-youtube"></i>YouTube</a>
                    <a href="{{candidateData.twitterProfile}}" *ngIf="candidateData.twitterProfile" target="_blank"><i
                            class="icofont-twitter"></i>Twitter</a>
                    <a href="{{candidateData.anotherSocialMediaAccount}}"
                        *ngIf="candidateData.anotherSocialMediaAccount" target="_blank"><i class="icofont-web"></i>Alta
                        retea</a>
                </div>
            </div>
        </div>

        <div class="row pb-20">
            <div class="col-md-8">
                <h2 class="custom-section-title">Educatie</h2>
                <div class="candidate-description">
                    <div class="education-list" *ngIf="candidateData.allUserStudies; else noEducation">
                        <div class="education-item" *ngFor="let item of candidateData.allUserStudies">
                            <div class="row education-info">
                                <div class="col-md-1 d-flex align-items-center">
                                    <i class="icofont-book-alt m"></i>
                                </div>
                                <div class="col-md-11">
                                    <p>{{item.diplomaStudies}}</p>
                                    <p>{{item.studyName}}</p>
                                    <span>{{item.studyStartDate | date:"dd-MM-yyyy"}} - {{item.studyEndDate | date:"dd-MM-yyyy"}},
                                    </span><span>{{item.studyLocation}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ng-template #noEducation>
                        <p>Nu ai adaugat nicio informatie legata de educatie.</p>
                    </ng-template>
                </div>
                <h2 class="custom-section-title pt-20">Nivel experienta</h2>
                <div class="row"
                    *ngIf="candidateData.currentJob || candidateData.userDepartment || candidateData.userActivitySector || candidateData.userActivitySubSector || candidateData.currentExperienceLevel || candidateData.jobType || candidateData.desiredLevelOfJob || candidateData.availableForWork; else noExperience">
                    <div class="col-md-6" *ngIf="candidateData.currentJob">
                        <p><b>Status job actual: </b> {{candidateData.currentJob | enumTransform}} </p>
                    </div>
                    <div class="col-md-6" *ngIf="candidateData.userDepartment">
                        <p><b>Departament: </b> <span
                                *ngFor="let department of candidateData.userDepartment; let i = index">{{department}}<span
                                    *ngIf="i+1 !== candidateData.userDepartment.length">, </span> </span></p>
                    </div>
                    <div class="col-md-6" *ngIf="candidateData.userActivitySector">
                        <p><b>Domeniu: </b> {{candidateData.userActivitySector | enumTransform}} </p>
                    </div>
                    <div class="col-md-6" *ngIf="candidateData.userActivitySubSector">
                        <p><b>Subdomeniu: </b> {{candidateData.userActivitySubSector | enumTransform}} </p>
                    </div>
                    <div class="col-md-6" *ngIf="candidateData.currentExperienceLevel">
                        <p><b>Nivelul experientei actuala: </b> {{candidateData.currentExperienceLevel | enumTransform}}
                        </p>
                    </div>
                    <div class="col-md-6" *ngIf="candidateData.jobType">
                        <p><b>Tip job: </b> {{candidateData.jobType | enumTransform}} </p>
                    </div>
                    <div class="col-md-6" *ngIf="candidateData.desiredLevelOfJob">
                        <p><b>Nivel de job dorit: </b> {{candidateData.desiredLevelOfJob | enumTransform}} </p>
                    </div>
                    <div class="col-md-6" *ngIf="candidateData.availableForWork">
                        <p><b>Disponibilitate angajare: </b> {{candidateData.availableForWork | enumTransform}} </p>
                    </div>
                </div>
                <ng-template #noExperience>
                    <p>Nu ai adaugat nicio informatie legata de nivel experienta.</p>
                </ng-template>
                <h4 class="custom-section-title pt-10 mb-5">Mobilitate geografica</h4>
                <div class="row"
                    *ngIf="candidateData.regionOfInterest || candidateData.availabilityOfRelocation || candidateData.driverLicense || candidateData.userAvailableForTraveling || candidateData.workPermissionInEu; else noMobility">
                    <div class="col-md-6" *ngIf="candidateData.regionOfInterest">
                        <p><b>Regiune de interes: </b> {{candidateData.regionOfInterest | enumTransform}} </p>
                    </div>
                    <div class="col-md-6" *ngIf="candidateData.availabilityOfRelocation">
                        <p><b>Disponibilitate de relocare: </b> {{candidateData.availabilityOfRelocation |
                            enumTransform}} </p>
                    </div>
                    <div class="col-md-6" *ngIf="candidateData.driverLicense">
                        <p><b>Permis de conducere: </b> {{candidateData.driverLicense}} </p>
                    </div>
                    <div class="col-md-6" *ngIf="candidateData.userAvailableForTraveling">
                        <p><b>Disponibilitate de deplasare: </b> {{candidateData.userAvailableForTraveling |
                            enumTransform}} </p>
                    </div>
                    <div class="col-md-6" *ngIf="candidateData.workPermissionInEu">
                        <p><b>Permis de munca in UE: </b> {{candidateData.workPermissionInEu | enumTransform}} </p>
                    </div>
                </div>
                <ng-template #noMobility>
                    <p>Nu ai adaugat nicio informatie legata de mobilitate geografica.</p>
                </ng-template>

                <div *ngIf="candidateData.linkVideoCV">
                    <h2 class="custom-section-title pt-20">Video CV</h2>
                    <iframe width="100%" height="415" [src]="videoCV | safe">
                    </iframe>
                </div>


                <h2 class="custom-section-title pt-20">Brandul tau de candidat</h2>
                <div *ngIf="candidateData.certification || candidateData.award || candidateData.top || candidateData.recommendation || candidateData.volunteering || candidateData.socialAction; else noBrand">
                    <div
                    *ngIf="candidateData.certification.length !== 0 || candidateData.award.length !== 0 || candidateData.top.length !== 0 || candidateData.recommendation.length !== 0 || candidateData.volunteering.length !== 0 || candidateData.socialAction.length !== 0; else noBrand">
                    <div *ngIf="candidateData.certification.length !== 0">
                        <p><b>Certificari (optional) :</b></p>
                        <div *ngFor="let item of candidateData.certification | keyvalue; let i=index;"
                            class="d-inline-flex mb-3">
                            <div class="d-flex align-items-center mr-2">{{item.value.title}}:</div>
                            <a href="{{item.value.link}}" target="_blank" class="btn btn-secondary mr-3"> Vezi fisier
                                {{i+1}} </a>
                        </div>
                    </div>
                    <div *ngIf="candidateData.award.length !== 0">
                        <p><b>Premii / Distinctii (optional): </b></p>
                        <div *ngFor="let item of candidateData.award | keyvalue;  let i=index;"
                            class="d-inline-flex mb-3">
                            <div class="d-flex align-items-center mr-2">{{item.value.title}}:</div>
                            <a href="{{item.value.link}}" target="_blank" class="btn btn-secondary mr-3"> Vezi fisier
                                {{i+1}} </a>
                        </div>
                    </div>
                    <div *ngIf="candidateData.top.length !== 0">
                        <p><b>Clasamente, topuri (optional): </b></p>
                        <div *ngFor="let item of candidateData.top | keyvalue; let i=index;" class="d-inline-flex mb-3">
                            <div class="d-flex align-items-center mr-2">{{item.value.title}}:</div>
                            <a href="{{item.value.link}}" target="_blank" class="btn btn-secondary mr-3"> Vezi fisier
                                {{i+1}} </a>
                        </div>
                    </div>
                    <div *ngIf="candidateData.recommendation.length !== 0">
                        <p><b>Testimoniale/ recomandari: </b></p>
                        <div *ngFor="let item of candidateData.recommendation | keyvalue; let i=index;"
                            class="d-inline-flex mb-3">
                            <div class="d-flex align-items-center mr-2">{{item.value.title}}:</div>
                            <a href="{{item.value.link}}" target="_blank" class="btn btn-secondary mr-3"> Vezi fisier
                                {{i+1}} </a>
                        </div>
                    </div>
                    <div *ngIf="candidateData.volunteering.length !== 0">
                        <p><b>Voluntariat: </b></p>
                        <div *ngFor="let item of candidateData.volunteering | keyvalue; let i=index;"
                            class="d-inline-flex mb-3">
                            <div class="d-flex align-items-center mr-2">{{item.value.title}}:</div>
                            <a href="{{item.value.link}}" target="_blank" class="btn btn-secondary mr-3"> Vezi fisier
                                {{i+1}} </a>
                        </div>
                    </div>
                    <div *ngIf="candidateData.socialAction.length !== 0">
                        <p><b>Implicare in actiuni sociale: </b></p>
                        <div *ngFor="let item of candidateData.socialAction | keyvalue; let i=index;"
                            class="d-inline-flex mb-3">
                            <div class="d-flex align-items-center mr-2">{{item.value.title}}:</div>
                            <a href="{{item.value.link}}" target="_blank" class="btn btn-secondary mr-3"> Vezi fisier
                                {{i+1}} </a>
                        </div>
                    </div>
                    <div *ngIf="candidateData.personalAchievement.length !== 0">
                        <p><b>Hobby-uri si realizari personale: </b></p>
                        <div *ngFor="let item of candidateData.personalAchievement | keyvalue; let i=index;"
                            class="d-inline-flex mb-3">
                            <div class="d-flex align-items-center mr-2">{{item.value.title}}:</div>
                            <a href="{{item.value.link}}" target="_blank" class="btn btn-secondary mr-3"> Vezi fisier
                                {{i+1}} </a>
                        </div>
                    </div>
                </div>
                </div>
                <ng-template #noBrand>
                    <p>Nu ai adaugat nicio informatie legata de brandul tau de candidat.</p>
                </ng-template>

                <h2 class="custom-section-title pt-20">Cunostinte</h2>
                <div class="pb-5" *ngIf="candidateData.otherCourses || candidateData.pcKnowledge">
                    <p *ngIf="candidateData.otherCourses"><b>Alte cursuri/ formari: </b> {{candidateData.otherCourses}} </p>
                    <p *ngIf="candidateData.pcKnowledge"><b>Cunostinte PC: </b> {{candidateData.pcKnowledge}} </p>
                </div>

                    <div>
                        <h4 class="custom-section-title pb-5">Limbi straine:</h4>
                        <div *ngIf="candidateData.foreignLanguage; else noKnowledge">
                            <div class="limbi-straine"
                            *ngFor="let item of candidateData.foreignLanguage | keyvalue">
                            <p>{{item.value.language}} - {{item.value.level}}</p>
                        </div>
                        </div>
                    </div>
                <ng-template #noKnowledge>
                    <p>Nu ai adaugat nicio informatie legata de limbi straine.</p>
                </ng-template>

                <h2 class="custom-section-title pt-20">Jobul ideal</h2>
                <h4 class="custom-section-title pb-5">Pachet salarial ideal</h4>
                <div class="row">
                    <div class="col-md-6">
                        <p><b>Salariu minim: </b> {{candidateData.minimumSalary}} </p>
                    </div>
                    <div class="col-md-6">
                        <p><b>Interesat de sisteme bonusare: </b> {{candidateData.interestedInBonusSystem |
                            enumTransform}} </p>
                    </div>
                    <div class="col-md-6">
                        <p><b>Bonuri de masa obligatorii: </b> {{candidateData.mandatoryMealVoucher | enumTransform}}
                        </p>
                    </div>
                    <div class="col-md-6">
                        <p><b>Bonuri de vacanta obligatorii: </b> {{candidateData.mandatoryHolidayVoucher |
                            enumTransform}} </p>
                    </div>
                    <div class="col-md-6">
                        <p><b>Masina de serviciu obligatorie: </b> {{candidateData.mandatoryServiceCar | enumTransform}}
                        </p>
                    </div>
                    <div class="col-md-6">
                        <p><b>Pachet de sanatate obligatoriu: </b> {{candidateData.mandatoryHealthPackage |
                            enumTransform}} </p>
                    </div>
                    <div class="col-md-6">
                        <p><b>Masa obligatorie: </b> {{candidateData.mandatoryFood | enumTransform}} </p>
                    </div>
                    <div class="col-md-6">
                        <p><b>Cazare obligatorie: </b> {{candidateData.mandatoryAccommodation | enumTransform}} </p>
                    </div>
                    <div class="col-md-6">
                        <p><b>Cursuri in tara: </b> {{candidateData.coursesInTheCountry | enumTransform}} </p>
                    </div>
                    <div class="col-md-6">
                        <p><b>Cursuri in afara tarii: </b> {{candidateData.coursesAboard | enumTransform}} </p>
                    </div>
                </div>

                <h4 class="custom-section-title pt-10 pb-5">Conditii de lucru ideale</h4>
                <div class="row" *ngIf="candidateData.userWorkProgram || candidateData.userWorkSpace || candidateData.physicalEffortAvailability || candidateData.weightLiftingAvailability || candidateData.workTemperature || candidateData.userCommute; else noConditions">
                    <div class="col-md-6" *ngIf="candidateData.userWorkProgram">
                        <p><b>Program de lucru:</b> {{candidateData.userWorkProgram | enumTransform}} </p>
                    </div>
                    <div class="col-md-6" *ngIf="candidateData.userWorkSpace">
                        <p><b>Spatiu de lucru: </b> {{candidateData.userWorkSpace | enumTransform}} </p>
                    </div>
                    <div class="col-md-6" *ngIf="candidateData.physicalEffortAvailability">
                        <p><b>Disponibilitate efort fizic: </b> {{candidateData.physicalEffortAvailability |
                            enumTransform}} </p>
                    </div>
                    <div class="col-md-6" *ngIf="candidateData.weightLiftingAvailability">
                        <p><b>Disponibilitate ridicare greutati: </b> {{candidateData.weightLiftingAvailability |
                            enumTransform}} </p>
                    </div>
                    <div class="col-md-6" *ngIf="candidateData.workTemperature">
                        <p><b>De acord sa lucrezi la diferite temeperaturi: </b> {{candidateData.workTemperature |
                            enumTransform}} </p>
                    </div>
                    <div class="col-md-6" *ngIf="candidateData.userCommute">
                        <p><b>Esti dispus sa faci naveta?: </b> {{candidateData.userCommute | enumTransform}} </p>
                    </div>
                </div>
                <ng-template #noConditions>
                    <p>Nu ai adaugat nicio informatie legata de conditii de lucru ideale.</p>
                </ng-template>

                <h4 class="custom-section-title pt-10 pb-5">Cariera ideala</h4>
                <div *ngIf="candidateData.idealCompany || candidateData.idealJob || candidateData.idealBenefits; else noIdealJob">
                    <p *ngIf="candidateData.idealCompany"><b>Compania ideala: </b>
                        <span [innerHTML]="candidateData.idealCompany"></span>
                        <!-- {{candidateData.idealCompany}}  -->
    
                    </p>
                    <p *ngIf="candidateData.idealJob"><b>Jobul ideal: </b>
                        <span [innerHTML]="candidateData.idealJob"></span>
                        <!-- {{candidateData.idealJob}}  -->
                    </p>
                    <p *ngIf="candidateData.idealBenefits"><b>Beneficii ideale: </b>
                        <!-- <p [innerHTML]="candidateData.idealBenefits"></p> -->
                        {{candidateData.idealBenefits | enumTransform}}
                    </p>
                </div>
                <ng-template #noIdealJob>
                    <p>Nu ai adaugat nicio informatie legata de cariera ideala.</p>
                </ng-template>

                <h2 class="custom-section-title pt-20">Abilitatile mele</h2>
                <div *ngIf="candidateData.ability; else noAbility">
                    <div *ngFor="let skill of candidateData.ability" class="pb-10">
                        <p *ngIf="skill.abilityName"><b>Abilitate: </b> {{skill.abilityName}} </p>
                        <p *ngIf="skill.abilityDescription"><b>Descriere abilitate: </b> {{skill.abilityDescription}} </p>
                        <p *ngIf="skill.abilityLevel"><b>Nivel abilitate: </b> {{skill.abilityLevel}} </p>
                    </div>
                </div>
                <ng-template #noAbility>
                    <p>Nu ai adaugat nicio informatie legata de abilitatile mele.</p>
                </ng-template>

            </div>
            <div class="col-md-4">
                <h2 class="custom-section-title">Experienta</h2>
                <div class="experience-list" *ngIf="candidateData.userExperience; else noExperience">
                    <div class="experience-item" *ngFor="let item of candidateData.userExperience">
                        <div class="experience-info">
                            <p>{{item.positionHeld}}, <b>{{item.employer}}</b></p>
                            <span>{{item.jobStartDate | date:"dd-MM-yyyy" }} - <span *ngIf="item.jobEndDate !== null">{{item.jobEndDate | date:"dd-MM-yyyy"}}</span><span *ngIf="item.jobEndDate === null">Prezent</span></span>
                        </div>
                        <div>
                            <p>{{item.town}}, {{item.country}}</p>
                        </div>
                        <div class="experience-description">
                            {{item.mainResponsibility}}
                        </div>
                    </div>
                </div>
                <ng-template #noExperience>
                    <p>Nu ai adaugat nicio informatie legata de experienta.</p>
                </ng-template>
            </div>
        </div>




        <!-- <div class="row informatii-temporar">
            <h2 class="custom-section-title">Informatiile tale</h2>
            <p><b>Evolutie profesionala: </b></p>
            <div class="limbi-straine" *ngFor="let item of candidateData.userExperience | keyvalue">
                <p><b>-Functie: </b> {{item.value.positionHeld}}</p>
                <p><b>-Angajator: </b> {{item.value.employer}}</p>
                <p><b>-Judet: </b> {{item.value.town}}</p>
                <p><b>-Tara: </b> {{item.value.country}}</p>
                <p><b>-Data inceput: </b> {{item.value.jobStartDate | date:"dd-MM-yyyy"}}</p>
                <p><b>-Data sfarsit: </b> {{item.value.jobEndDate | date:"dd-MM-yyyy" }}</p>
                <p><b>-Activitati principale: </b> {{item.value.mainResponsibility}}</p>
            </div>
        </div> -->
    </div>
</div>
<!--<div class="ended-jobs-section ptb-80">-->
<!--    <div class="container">-->
<!--        <div>-->
<!--            <h2 class="custom-section-title">Aplicarile mele</h2>-->
<!--        </div>-->
<!--        <div class="jobs-table">-->
<!--            <table id="ended-jobs" class="table">-->
<!--                <thead>-->
<!--                <tr>-->
<!--                    <th>Nume companie</th>-->
<!--                    <th>Titlul</th>-->
<!--                    <th>Locatie</th>-->
<!--                    <th>Categorie</th>-->
<!--                    <th>Data postarii</th>-->
<!--                </tr>-->
<!--                </thead>-->
<!--                <tbody>-->
<!--                <tr>-->
<!--                    <td>Indigo Violet</td>-->
<!--                    <td>HR Manager</td>-->
<!--                    <td class="job-location"><i class="icofont-location-pin"></i>Moscova, Rusia</td>-->
<!--                    <td>Banking</td>-->
<!--                    <td>24 Apr 2019</td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                    <td>Indigo Violet</td>-->
<!--                    <td>HR Manager</td>-->
<!--                    <td class="job-location"><i class="icofont-location-pin"></i>Moscova, Rusia</td>-->
<!--                    <td>Banking</td>-->
<!--                    <td>24 Apr 2019</td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                    <td>Indigo Violet</td>-->
<!--                    <td>HR Manager</td>-->
<!--                    <td class="job-location"><i class="icofont-location-pin"></i>Moscova, Rusia</td>-->
<!--                    <td>Banking</td>-->
<!--                    <td>24 Apr 2019</td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                    <td>Indigo Violet</td>-->
<!--                    <td>HR Manager</td>-->
<!--                    <td class="job-location"><i class="icofont-location-pin"></i>Moscova, Rusia</td>-->
<!--                    <td>Banking</td>-->
<!--                    <td>24 Apr 2019</td>-->
<!--                </tr>-->
<!--                </tbody>-->
<!--            </table>-->
<!--        </div>-->
<!--    </div>-->
<!--</div>-->
<app-footer></app-footer>
